import React from 'react'
import Project from '../../components/Project'
import { CRYPTOGRAPHY_PATH } from '../../routes'
import { otherProjectsWithout } from '../otherProjectsCardsInformation'

export default class ProofOfInnocenceProject extends React.Component {
    name(){
        return 'poi'
    }

    service(){
        return 'cryptography'
    }

    texts() {
        return this.props.texts
    }

    image() {
        return this.props.image
    }

    solutionsTexts() {
        return this.texts()['solutions']
    }

    otherProjects() {
        return otherProjectsWithout(this.name(),
            this.service(), this.solutionsTexts())
    }

    render() {
        return (
            <Project
                texts={this.texts()}
                projectImg={this.image()}
                otherProjects={this.otherProjects()}
                projectAreaPath={CRYPTOGRAPHY_PATH}
            />
        )
    }
}
